import { createContext, useContext } from 'react';

export interface TopBarAction {
  id?: string;
  label: string;
  onClick: () => void;
  primary?: boolean;
  expanded?: boolean;
  controls?: string;
}

interface TopBarContextType {
  setActions: (actions: TopBarAction[]) => void;
  setMobileTaskAction: (action: (() => void) | null) => void;
}

export const TopBarContext = createContext<TopBarContextType>({
  setActions: () => {},
  setMobileTaskAction: () => {},
});

export const useTopBarActions = () => useContext(TopBarContext);
